import React from 'react';
import { LineChart, Line, ResponsiveContainer, Tooltip as RCTooltip } from 'recharts';
import { Tooltip } from 'antd';
import { Link } from 'react-router-dom';
import { SvgIcon } from '../';
import './StatsWidgetChart.scss';

const series = [
    { amt: 0 },
    { amt: 2 },
    { amt: 6 },
    { amt: 9 },
    { amt: 15 },
    { amt: 20 },
    { amt: 25 },
  ];

  const TootipData = ({ active, payload }) => {
    if (active && payload && payload.length) {
      return (
        <div className="chart-tooltips">
          <div className="chart-tooltips-inner">
            {payload[0].value.toLocaleString()}
          </div>
        </div>
      )
    }
    return null
  }

const StatsWidget = ({url, externalurl, title, tooltip, statsnumbers, statspercents}) => {
    return (
        <>
            {url ? 
            <Link to={url} className="statswidget-card-chart">
                <div className="statswidget-card-inner">
                    <div className="left-statswidget">
                        <div className="statswidget-title"> 
                            {title}
                            {tooltip && (
                                <Tooltip title={tooltip}>
                                    <SvgIcon name="info" viewbox="0 0 13.75 13.75" />
                                </Tooltip>
                            )}
                        </div>
                        {statsnumbers && (
                            <div className="statswidget-number">
                                <h3>{statsnumbers}</h3>
                            </div>
                        )}
                        <div className="statswidget-percents">
                            <div>{statspercents && `+ ${statspercents}`}</div>
                        </div>
                    </div>
                    <div className="right-chart">
                        <ResponsiveContainer width="100%" height="80%">
                            <LineChart width={300} height={100} data={series}>
                                <Line type="monotone" dataKey="amt" stroke="#E85DF7" strokeWidth={1} dot={false} />
                                <RCTooltip content={<TootipData />} />
                            </LineChart>
                        </ResponsiveContainer>
                        <div className="my-2 bottom-label">30 Day Trend</div>
                    </div>
                </div>
            </Link> : 
            (externalurl  ? 
            <div onClick={()=> window.open(`${externalurl}`, '_blank')} className="statswidget-card-chart link-tag">
                <div className="statswidget-card-inner">
                    <div className="left-statswidget">
                        <div className="statswidget-title"> 
                            {title}
                            {tooltip && (
                                <Tooltip title={tooltip}>
                                    <SvgIcon name="info" viewbox="0 0 13.75 13.75" />
                                </Tooltip>
                            )}
                        </div>
                        {statsnumbers && (
                            <div className="statswidget-number">
                                <h3>{statsnumbers}</h3>
                            </div>
                        )}
                        <div className="statswidget-percents">
                            <div>{statspercents && `+ ${statspercents}`}</div>
                        </div>
                    </div>
                    <div className="right-chart">
                        <ResponsiveContainer width="100%" height="80%">
                            <LineChart width={300} height={100} data={series}>
                                <Line type="monotone" dataKey="amt" stroke="#E85DF7" strokeWidth={1} dot={false} />
                                <RCTooltip content={<TootipData />} />
                            </LineChart>
                        </ResponsiveContainer>
                        <div className="my-2 bottom-label">30 Day Trend</div>
                    </div>
                </div>
            </div> 
            : 
            <div className="statswidget-card-chart">
                <div className="statswidget-card-inner">
                    <div className="left-statswidget">
                        <div className="statswidget-title"> 
                            {title}
                            {tooltip && (
                                <Tooltip title={tooltip}>
                                    <SvgIcon name="info" viewbox="0 0 13.75 13.75" />
                                </Tooltip>
                            )}
                        </div>
                        {statsnumbers && (
                            <div className="statswidget-number">
                                <h3>{statsnumbers}</h3>
                            </div>
                        )}
                        <div className="statswidget-percents">
                            <div>{statspercents && `+ ${statspercents}`}</div>
                        </div>
                    </div>
                    <div className="right-chart">
                        <ResponsiveContainer width="100%" height="80%">
                            <LineChart width={300} height={100} data={series}>
                                <Line type="monotone" dataKey="amt" stroke="#E85DF7" strokeWidth={1} dot={false} />
                                <RCTooltip content={<TootipData />} />
                            </LineChart>
                        </ResponsiveContainer>
                        <div className="my-2 bottom-label">30 Day Trend</div>
                    </div>
                </div>
            </div>
            )}
        </>
    )
}

export default StatsWidget
